import Decimal from 'decimal.js';

const getProductionCycleTime = (limit: number, rate: number): string => {
  const limitDecimal = new Decimal(limit);
  const rateDecimal = new Decimal(rate);
  const production = limitDecimal.div(rateDecimal);

  const totalMinutes = production.mul(60).toNumber();
  const minutes = totalMinutes % 60;
  const hours = (totalMinutes - minutes) / 60;
  const minutesStr = minutes !== 0 ? ` ${Math.round(minutes)}m` : '';

  return `${hours}h${minutesStr}`;
};

export { getProductionCycleTime };
